import { AdjustmentFilter as PixiAdjustmentFilter } from 'pixi-filters';
import { assertNumberBetween } from '../../validators';
import { Config } from '../../video-data/config';
import type { BaseSettings } from '../TimeAwareBase';
import { Filter } from './Filter';
import { observable } from '../reactivity';

export class AdjustmentFilter extends Filter {
    static readonly NEUTRAL_BRIGHTNESS = 1.0;
    static readonly NEUTRAL_CONTRAST = 1.0;

    override _classType = Config.ADJUSTMENT_FILTER;
    override pixiFilter: PixiAdjustmentFilter;
    @observable accessor #brightness = AdjustmentFilter.NEUTRAL_BRIGHTNESS;
    @observable accessor #contrast = AdjustmentFilter.NEUTRAL_CONTRAST;

    constructor(settings: BaseSettings) {
        super(settings);
        this.pixiFilter = new PixiAdjustmentFilter();
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(['brightness', 'contrast']);
    }

    get brightness(): number {
        return this.#brightness;
    }

    set brightness(value: number) {
        if (value === this.#brightness) {
            return;
        }
        assertNumberBetween(value, 0, Infinity);
        this.#brightness = value;
        this.pixiFilter.brightness = value;
        this.requiresUpdate = true;
    }

    get contrast(): number {
        return this.#contrast;
    }

    set contrast(value: number) {
        if (value === this.#contrast) {
            return;
        }
        assertNumberBetween(value, 0, Infinity);
        this.#contrast = value;
        this.pixiFilter.contrast = value;
        this.requiresUpdate = true;
    }

    override isNeutral(): boolean {
        return (
            this.brightness === AdjustmentFilter.NEUTRAL_BRIGHTNESS &&
            this.contrast === AdjustmentFilter.NEUTRAL_CONTRAST
        );
    }
}
